import { render, staticRenderFns } from "./BookEdit.vue?vue&type=template&id=c6b2d398&"
import script from "./BookEdit.vue?vue&type=script&lang=js&"
export * from "./BookEdit.vue?vue&type=script&lang=js&"
import style0 from "./BookEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports